<template>
<div :style="{flex: flex ? flex : false }">
  <ControlLabel :field="field" :label="label" v-if="showLabel" />
  <div :class="{...(width ? {[`width-${width}`]: true} : {})}">
  <!-- If a custom slot is provided, render it directly (allows overriding e.g. <PhoneField placeholder="..." />) -->
  <slot v-if="$slots.default"></slot>
  <FormInput v-else-if="textField" :readonly="readonly" :limit="limit" :placeholder="placeholder"/>
  <TitleField v-else-if="field == 'title'" :simple="simpleTitle" :lang="lang"/>
  <PhoneField v-else-if="field == 'phone'" :readonly="readonly" />
  <CreditCardField v-else-if="field == 'card'" :check_text="check_text"  :lang="lang"/>
  <FormSelect v-else-if="selectField" ><slot /></FormSelect>
  <FormInput v-else />
  </div>
  <ErrorLabel/>
</div>
</template>
<script setup lang="ts">
import { computed, provide } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import type { Form } from '~/shared/form-types'

const props = withDefaults(defineProps<{
  field: keyof Form
  label?: string
  placeholder?: string
  lang?: string
  limit?: number
  simpleTitle?: boolean
  check_text?: string
  showLabel?: boolean
  width?: string
  flex?: number
  readonly?: boolean
}>(), {
  simpleTitle: false,
  check_text: 'Write checks out to XXXXX',
  showLabel: true
})

const { form } = usePaymentForm()

provide('field', props.field)

const textField = computed(() => [
  'firstName',
  'lastName',
  'honoreeName',
  'email',
  'street',
  'street2',
  'city',
  'zip',
  'accountID',
  'amount',
  'dedicationMessage',
  'description',
  'recipientName',
  'recipientEmail',
  'taxId',
].includes(props.field))

const selectField = computed(() => [
  'numberOfMonths',
  'dedication',
  'designation',
  'dateType',
].includes(props.field))
</script>